import React from "react"
import { navigate } from "gatsby"

const Secure = ({ component: Component, location, ...rest }) => {
  const validation =
    typeof window !== `undefined`
      ? localStorage.getItem("6d361f1d1c1160c1f")
      : null

  if (
    validation !== process.env.SUPPORT_TOKEN ||
    (validation === null &&
      location.pathname !== `/business-support/verify` &&
      typeof window !== `undefined`)
  ) {
    navigate("/business-support/")
    return null
  }

  return <Component {...rest} />
}

export default Secure
